<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <!--    <v-btn x-small text class="ml-5" @click="csv_export(table_id)"-->
    <!--      ><v-icon class="green&#45;&#45;text">mdi-microsoft-excel</v-icon></v-btn-->
    <!--    >-->

    <v-data-table
      :headers="headers"
      :items="items"
      options.multisort="True"
      :items-per-page="items_per_page"
      :sort-by.sync="sort_by"
      :sort-desc="sort_desc"
      class="elevation-1 ma-3 mytable"
      dense
      hide-default-header
      :id="table_id"
      :footer-props="{
        'items-per-page-options': calc_items_per_page(items ? items.length : 0),
      }"
    >
      <!-- custom header-->
      <template v-slot:header="{props}">
        <th
          v-for="(head, i) in props.headers"
          :key="head.id"
          :class="{
            table_narow: i < 4,
            table_wide: i >= 4,
            table_header_color_ix: i === 0,
            'text-start': i === 1,
            opportunities: head.text === 'Opportunities',
            opportunities: head.text === 'Main-Region',
            subregion: head.text === 'Sub-Region',
            headcol: i === 0,
          }"
        >
          <v-btn
            v-if="i === 0"
            x-small
            text
            class="ml-3"
            @click="
              html_to_xls_download_dialog_1pmc_country(
                table_id,
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                  .products.HS6_Code.length === 1
                  ? '_' +
                      $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                        .products.HS6_Code[0]
                  : '',
              )
            "
          >
            <v-icon class="green--text mb-12 mr-2">mdi-microsoft-excel</v-icon>
          </v-btn>

          <!--  apply buytton        -->
          <!--           v-if="i === 0 && enable_market_click && current_report_to_run === '1PMC'"-->
          <v-btn
            v-if="i === 0 && enable_market_click"
            @click="apply_market_selections"
            x-small
            class="yellow ml-1 mb-1 "
            :disabled="selected_items.length === 0"
            >Apply ({{ selected_items.length }})
          </v-btn>

          <v-tooltip top v-if="i > 1">
            <template v-slot:activator="{on, attrs}">
              <span
                v-html="head.text"
                v-on="on"
                @click="sort_clicked(head.value)"
                :class="{
                  'country-col': i === 1,
                  'reo-col': i === 2 && head.text !== 'Opportunities',
                }"
                class="sort-cursor"
              >
              </span>
              <span>
                <v-icon v-if="sort_by === head.value && i !== 0" class="text--accent-4">
                  {{ sort_desc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                </v-icon>
              </span>
            </template>
            <span
              >Sort
              {{ sort_desc && sort_by === head.value ? 'ascending' : 'descending' }}
            </span>
          </v-tooltip>

          <template v-else>
            <template v-if="head.text === 'Country'">
              <v-checkbox
                small
                v-model="enable_market_click"
                class="ml-4"
                @change="enable_disable_clicked"
              >
                <template v-slot:label>
                  <p class="caption narrow">
                    {{
                      !enable_market_click
                        ? 'Enable Selection Shortcuts'
                        : 'Disable Selection Shortcuts'
                    }}
                  </p>
                </template>
              </v-checkbox>
            </template>

            <template v-if="i !== 0">
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <span
                    v-html="head.text"
                    :class="{'ml-4': i === 1}"
                    class="sort-cursor"
                    v-on="on"
                    @click="sort_clicked(head.value)"
                  ></span>
                </template>
                <span
                  >Sort
                  {{ sort_desc && sort_by === head.value ? 'ascending' : 'desending' }}
                </span>
              </v-tooltip>
              <span>
                <v-icon v-if="sort_by === head.value && i !== 0" class="text--accent-4">
                  {{ sort_desc ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                </v-icon>
              </span>
            </template>

            <span
              v-else
              v-html="head.text"
              :class="{'ml-4': i === 1}"
              class="sort-cursor"
            ></span>
          </template>
        </th>
      </template>

      //Number Column
      <template v-slot:item.id_col="{item}">
        <div class="d-flex align-items-center justify-content-between pr-4">
          <span class="ma-1">{{ item['id_col'] }}</span>
          <input
            v-if="enable_market_click"
            type="checkbox"
            v-model="item['checked']"
            class="ma-1"
          />
        </div>
      </template>

      //Country only Column
      <template v-slot:item.C_Name="{item}">
        <span
          v-if="enable_market_click"
          class="text-left reo-table-selector"
          @click="table_click(item['C_Name'])"
        >
          {{ item['C_Name'] }}
        </span>
        <span v-else class="text-left reo-table-selector-off">
          {{ item['C_Name'] }}
        </span>
      </template>

      // REO Column
      <template v-slot:item.REO="{item}">
        <template v-if="item['REO_col'] >= 1 && item['REO_row'] >= 1">
          <v-tooltip bottom class="green">
            <template v-slot:activator="{on, attrs}">
              <p v-html="item['REO']" class="reo-col" v-on="on"></p>
            </template>
            <span
              >REO<sub>{{ item['REO_col'] }},{{ item['REO_row'] }}</sub>
              <br />
              {{ supply_text(item['REO_col'], item['C_Name'])['tooltip_text'] }}
              <br />
              {{ demand_text(item['REO_row'], item['C_Name'])['tooltip_text'] }}
            </span>
          </v-tooltip>
        </template>
        <span v-else class="reo-col ml-6">-</span>
      </template>

      // Tariff
      <template v-slot:item.ad_valorem_tariff="{item}" class="text-center">
        <v-tooltip left>
          <template v-slot:activator="{on, attrs}">
            <div class="text-center" v-on="on">
              <a :href="itc_url(item)" target="_blank" class="no-link">
                {{ format_ad_valorem(item.ad_valorem_tariff) }}</a
              >
            </div>
          </template>
          <span class="text-end">Click to view ITC tariff information</span>
        </v-tooltip>
        <!--        <span v-else class="ml-2"> - </span>-->
      </template>

      //opportunities or rank
      <template v-if="table_id === 'reo_country'" v-slot:item.Market_Rank="{item}">
        <div
          class="opportunities"
          v-bind:class="{'red--text': item['Market_Rank'] === 0}"
        >
          {{ item['Market_Rank'] }}
        </div>
      </template>
      <template v-slot:item.opportunities="{item}" v-else>
        <div class="opportunities">{{ item['opportunities'] }}</div>
      </template>

      //A
      <template v-slot:item.Avg6Major="{item}">
        <div class="text-center">
          {{ vFmt(item['Avg6Major'] * value_convertion, 2) }}
        </div>
      </template>

      //A1
      <template v-slot:item.Halal_Adj_Potential="{item}">
        <div class="text-center">
          {{ vFmt(item['Halal_Adj_Potential'] * value_convertion, 2) }}
        </div>
      </template>

      //B
      <template v-slot:item.HM_Exp_TM="{item}">
        <div class="text-center">
          {{
            parseFloat(vFmt(item['HM_Exp_TM'] * value_convertion, 2)) > 0
              ? vFmt(item['HM_Exp_TM'] * value_convertion, 2)
              : '-'
          }}
        </div>
      </template>

      //C
      <template v-slot:item.HM_TM_MShr="{item}">
        <div class="text-center">
          {{
            item['HM_Exp_TM'] / item['TW_import_product'] > 0 &&
            item['TW_import_product'] !== 0
              ? Math.round(
                  parseFloat(item['HM_Exp_TM'] / item['TW_import_product']) * 100 * 10,
                ) / 10
              : '-'
          }}
        </div>
      </template>

      //D
      <template v-slot:item.row_d="{item}">
        <div class="text-center">
          {{
            item['HM_Exp_TM'] / item['Avg6Major'] > 0 && item['Avg6Major'] !== 0
              ? ((item['HM_Exp_TM'] / item['Avg6Major']) * 100).toFixed(1)
              : '-'
          }}
        </div>
      </template>

      //E
      <template v-slot:item.Size6Major="{item}">
        <div class="text-center">
          {{
            parseFloat(vFmt(item['Size6Major'] * value_convertion, 2)) > 0
              ? vFmt(item['Size6Major'] * value_convertion, 2)
              : '-'
          }}
        </div>
      </template>

      //F
      <template v-slot:item.row_f="{item}">
        <div class="text-center">
          {{
            vFmt(
              (item['TW_import_product'] - item['Size6Major'] - item['HM_Exp_TM']) *
                value_convertion,
              2,
            ) >= 0
              ? vFmt(
                  (item['TW_import_product'] - item['Size6Major'] - item['HM_Exp_TM']) *
                    value_convertion,
                  2,
                )
              : '-'
          }}
        </div>
      </template>

      //G
      <template v-slot:item.TW_import_product="{item}">
        <div class="text-center">
          {{ vFmt(item['TW_import_product'] * value_convertion, 2) }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import dialogExcelTablesCountries from '@/components/application-level/helper-components/dialog-excel-tables-countries.vue';
import {eventBus} from '@/main';
import Swal from 'sweetalert2';
import {format_ad_valorem} from '@/components/application-level/js_functions/jsFunctions';
const {
  html_to_xls_download,
} = require('@/components/application-level/js_functions/jsFunctions');

const {
  calc_items_per_page,
} = require('@/components/trade-dsm-application/mixins/calc_items_per_page');

export default {
  name: 'reo_table_markets',
  props: {
    cube: String,
    table_id: String,
  },
  mounted() {
    // console.log('REO table is being mounted');
    // this.load_reo_definitions();

    eventBus.$on('CURRENCY_CHANGED', async () => {
      const cube = await this.gen_cube();
      this.items = cube['items'];
      this.headers = cube['headers'];
    });

    eventBus.$on('PRODUCTS_ENABLE_SELECTION_CLICKED', async () => {
      console.log('PRODUCTS_ENABLE_SELECTION_CLICKED');
      if (this.enable_market_click === true) {
        Swal.fire({
          title: 'Note',
          html: `<h3>Clicking product selection shortcut will ignore any market selections.
Do you want to continue?
</h3>`,
          width: 800,
          icon: 'warning',
          showCancelButton: true, // Enable the Cancel button
          confirmButtonText: 'Continue', // Change the text to "Continue"
          cancelButtonText: 'Cancel', // Add "Cancel" button text
        }).then(result => {
          if (result.isConfirmed) {
            this.enable_market_click = false;
          } else if (result.isDismissed) {
            eventBus.$emit('PRODUCTS_CLICK_CANCELLED');
            console.log('Cancel button was pressed'); // Log message when Cancel is pressed
          }
        });
      }
    });

    eventBus.$on('MARKETS_CLICK_CANCELLED', async () => {
      this.enable_market_click = false;
    });
  },

  data() {
    return {
      items: [], // Will hold the items
      headers: [], // Will hold the headers
      enable_market_click: false,
      sort_by: 'Avg6Major',
      sort_desc: true,
      items_per_page: 5,
    };
  },
  async created() {
    // Call gen_cube when the component is created to populate headers and items
    await this.clear_circ_ref_error();
    const cube = await this.gen_cube();
    this.items = cube['items'];
    this.headers = cube['headers'];
  },
  methods: {
    format_ad_valorem,
    enable_disable_clicked() {
      // this.enable_market_click = !this.enable_market_click;
      eventBus.$emit('MARKETS_ENABLE_SELECTION_CLICKED');
    },

    // eslint-disable-next-line no-unused-vars
    html_to_xls_download: html_to_xls_download,

    html_to_xls_download_dialog_1pmc_country(table_id, extra_text) {
      this.$store.state.app.activeDialogComponentProps = {
        ms_office_type: 'Excel',
        download_func: this.html_to_xls_download,
        table_id: table_id,
        extra_text: extra_text,
      };
      this.$store.state.app.activeDialogComponent = dialogExcelTablesCountries;
    },

    sort_clicked(column_name) {
      if (this.sort_by === column_name) {
        this.sort_desc = !this.sort_desc;
      } else {
        this.sort_by = column_name;
        this.sort_desc = !this.sort_desc;
      }
    },

    itc_url(item) {
      let home_market_code = '';
      if ('Home_Market' in this.$store.state.tradeDSM.dsm_filter_setttings) {
        home_market_code = this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market.slice(
          1,
        );
      }

      let target_market_code = '';
      if ('C_Code_x' in item) {
        target_market_code = item['C_Code_x'].slice(1);
      }

      let hs6_code = '';
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        hs6_code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0].slice(
          2,
          8,
        );
      }

      let year = 'none';
      try {
        year = item['ad_valorem_tariff_year'];
      } catch (e) {
        year = 2020;
      }

      return `https://macmap.org/en/query/customs-duties?reporter=${
        target_market_code === '158' ? '490' : target_market_code
      }&year=${year}&partner=${home_market_code}&product=${hs6_code}&level=6`;
    },

    calc_items_per_page: calc_items_per_page,

    async apply_market_selections() {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group.splice(
        0,
      );

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = this.selected_items;

      await this.update_results_cube();
    },
    async table_click(country_name) {
      const country_code = this.marketToCode(country_name);
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region.splice(
        0,
      );
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group.splice(
        0,
      );

      await this.$set(
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code,
        0,
        country_code,
      );

      await this.$store.commit('set_country_search_term', country_code);

      await this.update_results_cube();
    },
    column_sum(cube, column) {
      // Get the correct results cube -'cube'
      // Sum the column - 'cpolumn' in the 'cube'
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results[cube];

      let acc = 0;
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        acc += item[column];
      }
      return acc;
    },

    build_reo_column(col, row) {
      return `REO<sub>${col},${row}</sub>`;
    },
    async gen_cube() {
      await this.clear_circ_ref_error();
      let cube_values = JSON.parse(
        JSON.stringify(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            this.cube
          ],
        ),
      );
      console.table(cube_values);
      // console.log(cube_values[0]['']);
      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['num_col'] = i + 1;
        item['id_col'] = i + 1;
        item['checked'] = false;
        item['name'] = item;
        item['REO'] = this.build_reo_column(item['REO_col'], item['REO_row']);
        item['row_d'] =
          Math.round((item['HM_Exp_TM'] / item['Avg6Major']) * 10) / 10 > 0
            ? Math.round((item['HM_Exp_TM'] / item['Avg6Major']) * 10) / 10
            : '-';
        item['row_f'] =
          this.vFmt(
            (item['TW_import_product'] - item['Size6Major'] - item['HM_Exp_TM']) *
              this.value_convertion,
            2,
          ) >= 0
            ? this.vFmt(
                (item['TW_import_product'] - item['Size6Major'] - item['HM_Exp_TM']) *
                  this.value_convertion,
                2,
              )
            : '-';

        items.push(item);
      }

      let name_col = '';
      let col_name = '';

      if (this.cube === 'cube') {
        name_col = 'C_Name';
        col_name = 'Country';
      }
      if (this.cube === 'cube_Main_Region') {
        name_col = 'Main_Region';
        col_name = 'Main-Region';
      }
      if (this.cube === 'cube_C_Region') {
        name_col = 'C_Region';
        col_name = 'Sub-Region';
      }
      if (this.cube === 'cube_Trade_Block') {
        name_col = 'Trade_Block';
        col_name = 'Trade-Block';
      }
      return {
        headers: [
          {
            text: '#',
            value: 'id_col',
            class: 'table_header_color',
            fixed: true,
            width: '100px',
          },
          {
            text: col_name,
            value: name_col,
            class: 'table_header_color',
            fixed: true,
            width: '100px',
          },

          ...(this.cube === 'cube' &&
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
            .report_type_to_generate !== 'MPMC'
            ? [
                //conditional
                {
                  text: 'REO<sub>x,y</sub>',
                  value: 'REO',
                  class: 'table_header_color',
                },
                //Tariff
                {
                  text: 'Tariff*<br>[%]',
                  value: 'ad_valorem_tariff',
                  class: 'table_header_color',
                },
              ]
            : []),

          //opportunities
          {
            text:
              this.table_id === 'reo_country'
                ? `Rank <br> (out of ${items[0]['Market_REO_Count']})`
                : 'Opportunities',
            // value: this.table_id === 'reo_country' ? 'num_col' : 'opportunities',
            value: this.table_id === 'reo_country' ? 'Market_Rank' : 'opportunities',
            class: 'table_header_color',
          },

          // A
          {
            text:
              '[A] <br> Total Realistic Export Potential to ' +
              'Target Market(s) <br>' +
              this.totalValueStringHTML(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ),
            value: 'Avg6Major',
            class: 'table_header_color',
          },

          // A1
          {
            text:
              '[A1] <br> Halal reduced potential Target Market(s) <br>' +
              this.totalValueStringHTML(
                this.column_sum(this.cube, 'Halal_Adj_Potential'),
              ),
            value: 'Halal_Adj_Potential',
            class: 'table_header_color',
          },

          //B
          {
            text:
              '[B]<br> Total Exports from Home Market to Target Market(s) <br>' +
              this.totalValueStringHTML(this.column_sum(this.cube, 'HM_Exp_TM')),
            value: 'HM_Exp_TM',
            class: 'table_header_color',
          },
          //C
          {
            text: `[C] = [B] / [G] <br>Total Exports from Home Market / Target Market(s) Total Imports<br>

                ${
                  this.column_sum(this.cube, 'TW_import_product') > 0 //test for 0 don't device by 0
                    ? (
                        (this.column_sum(this.cube, 'HM_Exp_TM') /
                          this.column_sum(this.cube, 'TW_import_product')) *
                        100
                      ).toFixed(1)
                    : 0
                }
                %`,
            value: 'HM_TM_MShr',
            class: 'table_header_color',
          },

          //D
          {
            text: `[D] = [B] / [A] <br>Total Exports from Home Market / Realistic Export Potential <br>

                ${
                  this.column_sum(this.cube, 'Avg6Major') > 0 // test for 0, don't divide by 0.
                    ? (
                        (this.column_sum(this.cube, 'HM_Exp_TM') /
                          this.column_sum(this.cube, 'Avg6Major')) *
                        100
                      ).toFixed(1)
                    : 0
                }
              %`,
            value: 'row_d',
            class: 'table_header_color',
          },

          //E
          {
            text:
              '[E]<br> Target Market(s) Imports from T6 (Excl. Home Market)<br>' +
              this.totalValueStringHTML(this.column_sum(this.cube, 'Size6Major')),
            value: 'Size6Major',
            class: 'table_header_color',
          },

          //F  (comment)
          {
            text:
              '[F]<br> Target Market(s) Imports from Rest (Excl. Home Market)<br>' +
              this.totalValueStringHTML(
                this.column_sum(this.cube, 'TW_import_product') -
                  this.column_sum(this.cube, 'Size6Major') -
                  this.column_sum(this.cube, 'HM_Exp_TM'),
              ),
            value: 'row_f',
            class: 'table_header_color',
          },

          //G
          {
            text:
              '[G]<br> Target Market(s) Total Imports<br>' +
              this.totalValueStringHTML(this.column_sum(this.cube, 'TW_import_product')),
            value: 'TW_import_product',
            class: 'table_header_color',
          },

            ...(this.cube === 'cube' &&
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
            .report_type_to_generate !== 'MPMC'
            ? [
                 {
            text:
              "Adjusted <br> Herfindahl-Hirschman Index (Adj-HHI)",
            value: 'HHI_Adj',
            class: 'table_header_color',
          },
             {
            text:
              "Logistics Cost Index <br> <span class='text-caption'>(Ad Valorem Equivalent)</span>",
            value: 'ad_valorem_cost',
            class: 'table_header_color',
          },{
            text:
              "Market Access Index <br> <span class='text-caption'>(Ad Valorem Equivalent)</span>",
            value: 'ad_valorem_idx',
            class: 'table_header_color',
          },
              ]
            : []),






          //--------------------------------
        ],
        items: items,
      };
    },

    supply_text(REO_col, target_market) {
      let home_market = this.$store.state.app.selectedHomeCountry;
      // let target_market = this.codeToMarket(
      //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
      //         .C_Code[0],
      // );
      let hs6_code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.products.HS6_Code[0];
      let tooltip_text = target_market + ' does not seem to have sufficient information';
      if (REO_col > 0) {
        switch (REO_col) {
          case 1:
            tooltip_text =
              home_market +
              ' to date has supplied none or relatively little of ' +
              target_market +
              '’s total import demand for ' +
              hs6_code;
            break;
          case 2:
            tooltip_text =
              home_market +
              ' to date has supplied an intermediately small share of ' +
              target_market +
              '’s total import demand for ' +
              hs6_code;
            break;
          case 3:
            tooltip_text =
              home_market +
              ' to date has supplied an intermediately large share of ' +
              target_market +
              '’s total import demand for ' +
              hs6_code;
            break;
          case 4:
            tooltip_text =
              home_market +
              ' to date has supplied a relatively large share of ' +
              target_market +
              '’s total import demand for ' +
              hs6_code;
            break;
        }
        return {
          tooltip_text,
        };
      } else {
        tooltip_text = '';
        return {tooltip_text};
      }
    },
    // Mve to backend
    demand_text(REO_row, target_market) {
      let tooltip_text =
        'This opportunity is not classified as a realistic opportunity and therefore the market characteristics are not determined.';

      if (REO_row > 0) {
        switch (REO_row) {
          case 1:
            tooltip_text =
              target_market +
              "'s import demand is relatively large in global terms, but stable or ‘flat’ from a growth perspective.";
            break;
          case 2:
            tooltip_text =
              target_market +
              "'s import demand shows that it is growing in both the short and long term, but relative to other global markets it is a small market.";
            break;
          case 3:
            tooltip_text =
              target_market +
              "'s import demand is relatively large in global terms and has exhibited strong growth in the last 2 years (for which data is available).";
            break;
          case 4:
            tooltip_text =
              target_market +
              "'s import demand is relatively large in global terms and has exhibited strong growth over the last 5 years (for which data is available), but less so in the latest 2 years.";
            break;
          case 5:
            tooltip_text =
              target_market +
              "'s import demand is relatively large in global terms and has exhibited strong growth over the latest 2 years as well as in the last 5 years (for which data is available).";
            break;
        }
        return {
          tooltip_text,
        };
      } else {
        tooltip_text = '';
        return {tooltip_text};
      }
    },
  },
  computed: {
    selected_items() {
      return this.items
        .filter(item => item.checked)
        .map(item => item.C_Name)
        .map(C_Name => this.marketToCode(C_Name));
    },
  },
};
</script>

<style scoped>
.country-selector {
  transition-duration: 0.2s;
  border-radius: 5px;
  padding: 2px 2px 2px 5px;
  background-color: yellow; /* Green */
  color: #1f3c5f;
  display: inline-block;
  display: inline-block;
  width: 150px !important;
}

.country-selector:hover {
  color: yellow;
  cursor: pointer;
  padding: 2px 2px 2px 5px;
  background-color: #1f3c5f; /* Green */
}

.reo-table-selector {
  transition-duration: 0.2s;
  border-radius: 5px;
  padding: 2px 2px 2px 5px;

  color: #1f3c5f;
  display: inline-block;
  width: 170px !important;
}

.reo-table-selector:hover {
  color: yellow;
  cursor: pointer;
  padding: 2px 2px 2px 5px;
  background-color: #1f3c5f; /* Green */
}

.reo-table-selector-off {
  transition-duration: 0.2s;
  border-radius: 5px;
  padding: 2px 2px 2px 5px;

  display: inline-block;
  width: 170px !important;
}

.reo-table-selector-off:hover {
  padding: 2px 2px 2px 5px;
}

.country-col {
  display: inline-block;
  max-width: 200px !important;
}

.reo-col {
  display: inline-block;
  max-width: 60px !important;
  text-align: center;
}

.table_wide {
  background-color: lightgrey;
  color: black !important;
  font-size: 13px !important;
  padding: 3px;
  vertical-align: bottom;
  min-width: 120px;
}

.table_narow {
  background-color: lightgrey;
  color: black !important;
  font-size: 13px !important;
  padding: 3px;
  vertical-align: bottom;
  min-width: 10px;
}

.narrow {
  width: 75px;
}

.no-link {
  text-decoration: none;
}

.opportunities {
  text-align: center;
  min-width: 100px !important;
}

.subregion {
  text-align: center;
  min-width: 150px !important;
}
</style>
